<template>
  <div class="intersection-observer">
    <slot :intersected="intersected" />
  </div>
</template>

<script>
export default {
  name: "IntersectionObserver",
  props: {
    options: {
      type: Object,
      default: () => ({
        root: null,
        threshold: 0.15,
        rootMargin: "0px 0px 0px 0px",
      }),
    },
  },
  data: () => ({
    observer: null,
    intersected: false,
  }),
  mounted() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.intersected = true;
      }
    }, this.options);
    this.observer.observe(this.$el);
  },
  unmounted() {
    this.observer.disconnect();
  },
};
</script>

<style lang="scss" scoped>
.intersection-observer {
  position: relative;
}
</style>
